// extracted by mini-css-extract-plugin
export default {"wrapper":"PopoverBottomBar_wrapper__ll9ki"};